import { lazy } from 'react'

import generateRouterDetail from 'utils/helpers/generateRouterDetail'
import {
  MasterPayrollBulkUploadRBAC,
  MasterPayrollRBAC,
  MasterPayslipRBAC,
  MasterRateBulkUploadRBAC,
  MasterRateRBAC,
} from './rbac'

const MasterPayroll = lazy(
  () => import('../pages/MasterPayroll/MasterPayrollList/MasterPayrollList'),
)
const MasterPayrollOld = lazy(() => import('../pages/MasterPayrollv1/MasterPayrollList'))
const MasterPayrollOldDetail = lazy(() => import('../pages/MasterPayrollv1/MasterPayrollDetail'))
const MasterPayrollBulkUpload = lazy(() => import('../pages/MasterPayroll/MasterPayrollBulkUpload'))

const MasterPayslip = lazy(() => import('../pages/MasterPayslip/MasterPayslipList'))
const MasterRate = lazy(() => import('../pages/MasterRate/MasterRateList'))
const MasterRateBulkUpload = lazy(() => import('../pages/MasterRate/MasterRateBulkUpload'))

export const MasterPayrollRouter: RouterFeatureInterface<
  'MasterPayroll',
  '/dashboard/master-payroll'
> = {
  name: 'MasterPayroll',
  Component: MasterPayroll,
  path: '/dashboard/master-payroll',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: MasterPayrollRBAC.pageID,
  isDashboard: true,
}

export const MasterPayrollBulkUploadRouter: RouterFeatureInterface<
  'MasterPayrollBulkUpload',
  '/dashboard/master-payroll/bulk-upload'
> = {
  name: 'MasterPayrollBulkUpload',
  Component: MasterPayrollBulkUpload,
  path: '/dashboard/master-payroll/bulk-upload',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: MasterPayrollBulkUploadRBAC.pageID,
}

export const MasterPayrollOldRouter: RouterFeatureInterface<
  'MasterPayrollOld',
  '/dashboard/master-payroll-old'
> = {
  name: 'MasterPayrollOld',
  Component: MasterPayrollOld,
  path: '/dashboard/master-payroll-old',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: MasterPayrollRouter.rbacPageID,
  isDashboard: true,
}

export const MasterPayrollOldDetailsRouter: RouterFeatureInterface<
  'MasterPayrollOldDetail',
  '/dashboard/master-payroll-old/:id'
> = {
  name: 'MasterPayrollOldDetail',
  Component: MasterPayrollOldDetail,
  path: '/dashboard/master-payroll-old/:id',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: MasterPayrollRouter.rbacPageID,
}

export const MasterPayslipRouter: RouterFeatureInterface<
  'MasterPayslip',
  '/dashboard/master-payslip'
> = {
  name: 'MasterPayslip',
  Component: MasterPayslip,
  path: '/dashboard/master-payslip',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: MasterPayslipRBAC.pageID,
}

export const MasterRateRouter: RouterFeatureInterface<'MasterRate', '/dashboard/master-rate'> = {
  name: 'MasterRate',
  Component: MasterRate,
  path: '/dashboard/master-rate',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: MasterRateRBAC.pageID,
}

export const MasterRateBulkUploadRouter: RouterFeatureInterface<
  'MasterRateBulkUpload',
  '/dashboard/master-rate/bulk-upload'
> = {
  name: 'MasterRateBulkUpload',
  Component: MasterRateBulkUpload,
  path: '/dashboard/master-rate/bulk-upload',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: MasterRateBulkUploadRBAC.pageID,
}

const PayrollRouter = [
  MasterPayrollRouter,
  MasterPayrollBulkUploadRouter,
  MasterPayrollOldRouter,
  MasterPayrollOldDetailsRouter,
  MasterPayslipRouter,
  MasterRateRouter,
  MasterRateBulkUploadRouter,
]

export const PayrollRouterDetail = generateRouterDetail(PayrollRouter)

export default PayrollRouter
